import { useEffect, useState } from "react";
import { getAvailablePropertyTypes } from "./service";

export default function useAlertInitialization({ personId, mlsIds }) {
  const [errorMessage, setErrorMessage] = useState("");
  const [propertyTypes, setPropertyTypes] = useState([]);
  useEffect(() => {
    if (!personId) return;
    if (mlsIds === null) return;

    if (!mlsIds.length) {
      setErrorMessage("No MLSs are configured for your account. Please contact support.");
      return;
    }
    const fetchPropertyTypes = async () => {
      try {
        const propertyTypesRes = await getAvailablePropertyTypes(personId, mlsIds);
        setPropertyTypes(propertyTypesRes);
      } catch (error) {
        console.error("Failed to fetch property types:", error);
      }
    };
    fetchPropertyTypes();
    setErrorMessage("");
  }, [personId, mlsIds]);

  return {
    errorMessage,
    propertyTypes,
  };
}
